import { SelectActivity } from "pages/attendance-confirmation/activity/SelectActivity";
import { AttendanceConfirmation } from "pages/attendance-confirmation/AttendanceConfirmation";
import { Attendance } from "pages/attendance/attendance";
import { Attendees } from "pages/attendees/attendees";
import { Channel } from "pages/channel/channel";
import { Pathway } from "pages/pathway/pathway";
import { Playlist } from "pages/playlist/playlist";
import { SubmitAttendance } from "pages/submit-attendance/submit-attendance";
import { PERMISSIONS } from "utils/constants";
import ProtectedRoute from "./protected-route";
import { ActivityAttendeesComp as ActivityAttendees } from "pages/attendance-confirmation/activity/ActivityAttendees";
import { Routes, Route } from "react-router-dom";

export const LEAPRoutes = (): React.ReactElement => {
  return (
    <Routes>
      <Route path="/attendance" element={<ProtectedRoute permissions={[PERMISSIONS.CAN_MANAGE_ATTENDANCE]}><Attendance /></ProtectedRoute>} />
      <Route path="/attendees/:sessionId" element={<ProtectedRoute permissions={[PERMISSIONS.CAN_MANAGE_ATTENDANCE]}><Attendees /></ProtectedRoute>} />
      <Route path="/submit/:sessionId" element={<ProtectedRoute permissions={[PERMISSIONS.CAN_MANAGE_ATTENDANCE]}><SubmitAttendance /></ProtectedRoute>} />
      <Route path="/attendance-confirmation/activity/:activityId" element={<ProtectedRoute permissions={[PERMISSIONS.CAN_MANAGE_ATTENDANCE]}><ActivityAttendees /></ProtectedRoute>} />
      <Route path="/attendance-confirmation/activity" element={<ProtectedRoute permissions={[PERMISSIONS.CAN_MANAGE_ATTENDANCE]}><SelectActivity /></ProtectedRoute>} />
      <Route path="/attendance-confirmation" element={<ProtectedRoute permissions={[PERMISSIONS.CAN_MANAGE_ATTENDANCE]}><AttendanceConfirmation /></ProtectedRoute>} />
      <Route path="/pathway/:id" element={<ProtectedRoute><Pathway /></ProtectedRoute>} />
      <Route path="/parent_pathway/:id" element={<ProtectedRoute><Pathway /></ProtectedRoute>} />
      <Route path="/playlist/:id" element={<ProtectedRoute><Playlist /></ProtectedRoute>} />
      <Route path="/channel/:id" element={<ProtectedRoute><Channel /></ProtectedRoute>} />
    </Routes>
  );
};
